import { FORMAT, dayjs, isSameDay, isTomorrow } from 'utils/date';

const isMidday = dateTime => dateTime.hour() === 12 && dateTime.minute() === 0;

export const formatAmendCutOffDate = date => dayjs(date).tz().format(FORMAT.LONG_DAY_MONTH);

export const formatAmendCutOffTime = date => {
  const cutOffDateTime = dayjs(date).tz();
  const cutOffTime = cutOffDateTime.format(`${FORMAT.HOUR_MINUTE_AMPM}`);
  return isMidday(cutOffDateTime) ? '12:00 midday' : cutOffTime.replace(':00', '');
};

export const formatAmendCutOffDateTime = date => {
  const isToday = isSameDay(dayjs(date).tz(), dayjs().tz());
  const tomorrow = isTomorrow(dayjs(date).tz());

  if (isToday) {
    return `${formatAmendCutOffTime(date)} today`;
  }

  if (tomorrow) {
    return `${formatAmendCutOffTime(date)} tomorrow`;
  }

  return `${formatAmendCutOffTime(date)} on ${formatAmendCutOffDate(date)}`;
};
